import React from 'react';
import useNextDesign from './useNextDesign';

/**
 * NextRoute — renders the rebuilt (crm-kit/next) screen in the new design,
 * and the existing screen in the old one.
 */
export default function NextRoute({ next: Next, legacy: Legacy, ...props }) {
  const { enabled } = useNextDesign();
  return enabled ? <Next {...props} /> : <Legacy {...props} />;
}
